import axios from 'axios'

const state = {
        
        user:{
            name:'',
            role:'',

        },
        users: [],
    };

const getters = {
    userList: state => state.users
};

const mutations = {
    setUsers: (state, users) => state.users = users,
    addNewUser: (state, user) => state.users.unshift(user),
    removeUser: (state, user) => state.users.shift(user) 
};

const actions = {
    async fetchUsers({commit}) {
        const response = await axios("")
        commit("setUsers", response.data)
    }
};


export default {

    namespaced: true,
    state,
    getters,
    mutations,
    actions
   }
